import type { OrderServiceGetManyRequest } from '@/models/orders';
import { fetchOrders } from '@/services/orders';
import type { ModelOrderResponse } from '@layup/api-sdk';

export const getUnresolvedCancellations = (orders: ModelOrderResponse[]): ModelOrderResponse[] => {
  return orders.filter((order) => {
    if (!order.notifications) {
      return false;
    }
    const cancellationNotifications = order.notifications.filter(
      (notification) => notification.type === 'CANCELLATION',
    );

    if (cancellationNotifications.length <= 0) return false;

    const lastNotification = cancellationNotifications[cancellationNotifications.length - 1];
    return lastNotification.read === false && lastNotification.change === 'DISPUTE';
  });
};

export const fetchUnresolvedCancellations = async (
  params?: OrderServiceGetManyRequest,
): Promise<ModelOrderResponse[] | null> => {
  const orderParams: OrderServiceGetManyRequest = {
    limit: 500,
    state: 'PLACED',
    orderCancellationRequest: 'DISPUTE',
    ...params,
  };
  const orderResponse = await fetchOrders(orderParams);
  return orderResponse.orders ? getUnresolvedCancellations(orderResponse.orders) : null;
};
